import { Observable } from 'rxjs'
import { ContactusDetail } from '../models/contact'

export abstract class ContactusGateway {
    abstract GetCotactContent(ParentName: string, SectionName: string, insCo: number, planyear: number): Observable<ContactusDetail[]>
}
